module.exports = __webpack_public_path__ + "img/2021_CellResearch.26272ded.png";